import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
import {
  Button, message, Icon, Popconfirm,
} from 'antd';

import PageHeader from '../../components/PageHeader';
import Container from '../../components/Container';
import StatusTaggingForm from '../../components/StatusTaggingForm';
import {
  fetchTransmittalTrackingNumberRefusal,
  submitTransmittal,
  fetchOptions,
  updateTrackingNumberStatus,
  fetchTrackingNumber,
} from '../ducks';

export class MerchantPickupRefusal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      trackingNumberRows: [],
      errors: [],
      options: [],
      sucessRows: [],
    };

    this.validatePackage = this.validatePackage.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.confirmRemove = this.confirmRemove.bind(this);
  }

  componentDidMount() {
    const { doFetchOptions } = this.props;
    doFetchOptions('fm_reason').then(res => this.setState({
      options: res.payload.data,
    }));
  }

  submitForm() {
    const { trackingNumberRows } = this.state;
    const { doFetchTransmittalTrackingNumberRefusal } = this.props;
    // const packageList = [];

    // eslint-disable-next-line no-unused-vars
    // trackingNumberRows.forEach((item, key) => {
    //   packageList.push(item.tracking_number);
    // });
    const addressFilter = trackingNumberRows.map(account => account.address_city);
    const referenceFilter = trackingNumberRows.map(account => account.reference);
    const trackingNumberFilter = trackingNumberRows.map(account => account.tracking_number);
    const commentFilter = trackingNumberRows.map(account => account.comment);
    for (let i = 0; i < trackingNumberRows.length; i++) {
      const comment = commentFilter ? { comment: commentFilter[i] } : null;
      const payload = {
        address_city: addressFilter[i],
        current_status: 'accepted_by_courier',
        reference_code: referenceFilter[i],
        status: 'fm_refused',
        tracking_number: trackingNumberFilter[i],
        ...comment,
      };

      doFetchTransmittalTrackingNumberRefusal(payload, trackingNumberFilter[i])
        .then((action) => {
          this.setState(prevState => ({
            trackingNumberRows: [],
            sucessRows: [...prevState.sucessRows, action.payload.data],
          }));
          message.success('Package update successfully!', 5);
        })
        .catch(() => {
          message.error('Something went wrong, please try again later.');
        });
      // console.log(payload);
    }
    // console.log(trackingNumberRows);
  }

  validatePackage(values) {
    const { trackingNumberRows } = this.state;
    const { doFetchTrackingNumber } = this.props;

    const splitTrackingNumber = values.trackingNumber ? values.trackingNumber.split('\n') : '';
    const filteredTrackingNumber = splitTrackingNumber.filter(
      (item, key) => splitTrackingNumber.indexOf(item) >= key && item !== '',
    );
    // eslint-disable-next-line no-unused-vars
    filteredTrackingNumber.forEach((item, key) => {
      const exists = trackingNumberRows.filter(tn => tn.tracking_number === item);

      if (exists.length > 0) {
        message.error(`Tracking number ${item} is already entered.`);
        this.setState(prevState => ({
          errors: [
            ...prevState.errors,
            {
              tracking_number: item,
              message: 'Tracking number is already entered.',
            },
          ],
        }));
      } else {
        doFetchTrackingNumber('fm_refused', item)
          .then((action) => {
            this.setState(prevState => ({
              trackingNumberRows: [
                ...prevState.trackingNumberRows,
                {
                  tracking_number: action.payload.data.tracking_number,
                  status: action.payload.data.status,
                  target_status: 'fm_refused',
                  reference: values.reason,
                  comment: values.comment,
                  address_city: action.payload.data.address_city,
                },
              ],
            }));
            message.success('Successfully added tracking number!.');
          })
          .catch((action) => {
            let errorMessage;
            if (action.error.response.status === 400) {
              errorMessage = action.error.response.data.message;
              this.setState(prevState => ({
                errors: [
                  ...prevState.errors,
                  {
                    tracking_number: item,
                    message: action.error.response.data.message,
                  },
                ],
              }));
            } else {
              errorMessage = 'Something went wrong, please try again later.';
            }
            message.error(errorMessage, 3);
          });
      }
    });
  }

  confirmRemove(trackingNumber) {
    const { trackingNumberRows } = this.state;
    const filteredTrackingNumber = trackingNumberRows.filter(
      data => data.tracking_number !== trackingNumber,
    );

    this.setState({
      trackingNumberRows: filteredTrackingNumber,
    });

    message.success('Successfully removed tracking number!');
  }

  render() {
    const {
      trackingNumberRows, errors, options, sucessRows,
    } = this.state;
    const breadCrumbs = [
      {
        breadcrumbName: 'Packages',
      },
      {
        breadcrumbName: 'Transmittal Refusal',
      },
      {
        breadcrumbName: 'Refusal',
      },
    ];

    const trackingNumberRowColumns = [
      {
        Header: 'Tracking Number',
        accessor: 'tracking_number',
      },
      {
        Header: 'Current Status',
        accessor: 'status',
      },
      {
        Header: 'Target Status',
        accessor: 'target_status',
      },
      {
        Header: 'Reference',
        accessor: 'reference',
      },
      {
        Header: 'Comment',
        accessor: 'comment',
      },
      {
        Header: 'Options',
        sortable: false,
        filterable: false,
        Cell: data => (
          <React.Fragment>
            <Popconfirm
              placement="leftBottom"
              title={`Are you sure you want to delete ${data.row.tracking_number} from the list?`}
              okText="Yes"
              onConfirm={() => this.confirmRemove(data.row.tracking_number)}
              cancelText="No"
            >
              <Button type="link" block>
                <Icon viewBox="0 0 1024 1024">
                  <FontAwesomeIcon icon={faTrash} fixedWidth />
                </Icon>
                Remove
              </Button>
            </Popconfirm>
          </React.Fragment>
        ),
      },
    ];

    return (
      <div className="MerchantPickupRefusal">
        <PageHeader title="Transmittal" routes={breadCrumbs} />
        <Container>
          <StatusTaggingForm
            hasDatePicker={false}
            validateHandler={this.validatePackage}
            submitHandlerRefusal={e => this.submitForm(e)}
            trackingNumberList={trackingNumberRows}
            trackingNumberListColumns={trackingNumberRowColumns}
            errorList={errors}
            options={options}
            isFailedStatusRefusal
            isRefusalSuccess
            successList={sucessRows}
          />
        </Container>
      </div>
    );
  }
}

MerchantPickupRefusal.propTypes = {
  doFetchTransmittalTrackingNumberRefusal: PropTypes.func.isRequired,
  doFetchOptions: PropTypes.func.isRequired,
  doFetchTrackingNumber: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  doFetchTransmittalTrackingNumberRefusal: fetchTransmittalTrackingNumberRefusal,
  doSubmitTransmittal: submitTransmittal,
  doFetchOptions: fetchOptions,
  doUpdateTrackingNumberStatus: updateTrackingNumberStatus,
  doFetchTrackingNumber: fetchTrackingNumber,
};

export default connect(
  null,
  mapDispatchToProps,
)(MerchantPickupRefusal);
